import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { SideTabs } from "shared/tabs"
import AttributesTab from "./AttributesTab"
import GeneralTab from "./GeneralTab"
import DepartmentsTab from "./DepartmentsTab"
import AuditTrailTab from "./AuditTrailTab"

const TABS = (tabProps, departmentsTabTitle) => [
  {
    title: "General",
    TabContent: GeneralTab,
    props: tabProps,
  },
  {
    title: "Attributes",
    TabContent: AttributesTab,
    props: tabProps,
  },
  {
    title: departmentsTabTitle,
    TabContent: DepartmentsTab,
    props: tabProps,
  },
  {
    title: "Audit Trail",
    TabContent: AuditTrailTab,
    props: tabProps,
  },
]

const FacilityTabs = ({ tabProps = {} }) => {
  const { pluralName: departmentsTabTitle } = useCustomName(DEPARTMENT_KEY)

  return (
    <SideTabs tabs={TABS(tabProps, departmentsTabTitle)} />
  )
}

FacilityTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object,
}

export default FacilityTabs
